<template>
  <div class="container-wrapper">
    <div class="container page-wrapped page-first">
      <div class="container-row">
        <div class="half-backdrop">
        </div>
        <div class="container-left">
          <div>
            <div class="title-text-1">
              A lighthearted game to keep your team connected
            </div>
            <div class="register-button" @click="startDemo">
              <div class="register-button-content">
                Try an instant demo
              </div>
            </div>
          </div>
        </div>
        <div class="container-right" >
          <div class="main-layout-item main-layout-half" style="font-size: 2.2em;">
            <div class="gif-prompt-example">
              <div class="gif-prompt-example-title" style="font-size: 0.4em;">
                How you feel after a meeting with no clear takeaways
              </div>
            </div>
            <div class="player-image-border-absolute deg0-circular">
              <div class="player-image">
                <img src="@/assets/landing/rectangle-1.png">
              </div>
            </div>
            <div class="player-image-border-absolute deg60-circular">
              <div class="player-image">
                <img src="@/assets/landing/rectangle-2.png">
              </div>
            </div>
            <div class="player-image-border-absolute deg120-circular">
              <div class="player-image">
                <img src="@/assets/landing/rectangle-3.png">
              </div>
            </div>
            <div class="player-image-border-absolute deg180-circular">
              <div class="player-image">
                <img src="@/assets/landing/rectangle-4.png">
              </div>
            </div>
            <div class="player-image-border-absolute deg240-circular">
              <div class="player-image">
                <img src="@/assets/landing/rectangle-5.png">
              </div>
            </div>
            <div class="player-image-border-absolute deg300-circular">
              <div class="player-image">
                <img src="@/assets/landing/rectangle-6.png">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container page-wrapped page-second">
      <div class="container-row">
        <div class="container-left">
          <div class="title-text-2">
            Bring your team together
          </div>
          <div>
            <img src="@/assets/landing/urban-line.png" style="mix-blend-mode: luminosity; width: 100%;">
          </div>
        </div>
        <div class="container-right">
          <div class="container-item">
            <div class="container-row">
              <div class="column-item left-align column-item-shorter">
                <div class="circle circle-white">
                  <img src="@/assets/landing/coffee-cup.png">
                </div>
              </div>
              <div class="column-item left-align column-item-longer">
                <div class="font-size-large block-title bold caps">
                  Zoom out, relax, and play
                </div>
                <div class="font-size-small">
                  Step outside the fray of day-to-day productivity tools and have some fun poking at common workplace pitfalls and pleasantries.
                </div>
              </div>
            </div>
          </div>
          <div class="container-item">
            <div class="container-row">
              <div class="column-item left-align column-item-shorter">
                <div class="circle circle-white">
                  <img src="@/assets/landing/support.png">
                </div>
              </div>
              <div class="column-item left-align column-item-longer">
                <div class="font-size-large block-title bold caps">
                  Get to the heart of it
                </div>
                <div class="font-size-small">
                  Get to know your teammates' preferences. What fires them up? What bothers them? What can't they say no to? Find out!
                </div>
              </div>
            </div>
          </div>
          <div class="container-item">
            <div class="container-row">
              <div class="column-item left-align column-item-shorter">
                <div class="circle circle-white">
                  <img src="@/assets/landing/idea.png">
                </div>
              </div>
              <div class="column-item left-align column-item-longer">
                <div class="font-size-large block-title bold caps">
                  Company culture, center stage
                </div>
                <div class="font-size-small">
                  Get those unspoken, hard-to-learn nuances about your company's culture out and into the open by making the implicit explicit.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class = "container page-third">
      <div class="container-item" id="howToAnchor">
        <div style="height: 3em" />
      </div>
      <div class="container-item">
        <div class="title-text-2">
          How to Play
        </div>
      </div>
      <div class="container-row">
        <div style="height: 1em" />
      </div>
      <div class="container-item">
        <div class="container-row">
          <div class="column-item container-left left-align">
            <div class="font-size-large block-title">
              STEP 1            
            </div>
            <div class="font-size-large bold block-title caps">
              Invite your team to play
            </div>
            <div class="font-size-small ">
              Invite up to 7 teammates to play with you by sharing a private room code. They’ll instantly be brought into a game lobby and assigned a seat.
            </div>
          </div>
          <div class="column-item container-right container-fixed-height">
            <img src="@/assets/landing/inviting.png">
          </div>
        </div>
        <div class="container-row">
          <div style="height: 4em" />
        </div>
        <div class="container-row">
          <div class="column-item container-left left-align">
            <div class="font-size-large block-title">
              STEP 2            
            </div>
            <div class="font-size-large bold block-title caps">
              Respond to prompts about team & work culture
            </div>
            <div class="font-size-small ">
              At the beginning of each round, players anonymously share whimsical answers to prompts about their team and culture.
            </div>
          </div>
          <div class="column-item container-right container-fixed-height">
            <div class="main-layout-item main-layout-half">
              <div class="gif-prompt-example">
                <div class="gif-prompt-example-title">
                  How you feel after a meeting with no clear takeaways
                </div>
              </div>
              <div class="player-image-border-absolute deg30">
                <div class="player-image">
                  <img src="@/assets/landing/rectangle-1.png">
                </div>
              </div>
              <div class="player-image-border-absolute deg90">
                <div class="player-image">
                  <img src="@/assets/landing/rectangle-2.png">
                </div>
              </div>
              <div class="player-image-border-absolute deg150">
                <div class="player-image">
                  <img src="@/assets/landing/rectangle-3.png">
                </div>
              </div>
              <div class="player-image-border-absolute deg210">
                <div class="player-image">
                  <img src="@/assets/landing/rectangle-4.png">
                </div>
              </div>
              <div class="player-image-border-absolute deg270">
                <div class="player-image">
                  <img src="@/assets/landing/rectangle-5.png">
                </div>
              </div>
              <div class="player-image-border-absolute deg330">
                <div class="player-image">
                  <img src="@/assets/landing/rectangle-6.png">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-row">
          <div style="height: 6em" />
        </div>
        <div class="container-row">
          <div class="column-item container-left left-align">
            <div class="font-size-large block-title">
              STEP 3            
            </div>
            <div class="font-size-large bold block-title caps">
              Let the voting and banter begin
            </div>
            <div class="font-size-small">
              After everyone has submitted their answers, all players vote on the answer they like best for the prompt. It’s a bit like a duel, with two players facing off against each other, trying to acquire the most points possible.
            </div>
          </div>
          <div class="column-item container-right container-fixed-height">
            <div class="main-layout-item main-layout-half main-layout-height">
              <div class="container-image-16-9 img-left">
                <img src="@/assets/landing/james-harden-walk-away.gif">
              </div>
              <div class="container-image-16-9 img-right">
                <img src="@/assets/landing/mandeep-dhillon-fake-laugh.gif">
              </div>
              <div class="circle circle-left">
                40 pts
              </div>
              <div class="circle circle-right">
                20 pts
              </div>
              <div class="player-image-border-absolute deg30">
                <div class="player-image">
                  <img src="@/assets/landing/rectangle-1.png">
                </div>
              </div>
              <div class="player-image-border-absolute deg90">
                <div class="player-image">
                  <img src="@/assets/landing/rectangle-2.png">
                </div>
              </div>
              <div class="player-image-border-absolute deg150">
                <div class="player-image">
                  <img src="@/assets/landing/rectangle-3.png">
                </div>
              </div>
              <div class="player-image-border-absolute deg210">
                <div class="player-image">
                  <img src="@/assets/landing/rectangle-4.png">
                </div>
              </div>
              <div class="player-image-border-absolute deg270">
                <div class="player-image">
                  <img src="@/assets/landing/rectangle-5.png">
                </div>
              </div>
              <div class="player-image-border-absolute deg330">
                <div class="player-image">
                  <img src="@/assets/landing/rectangle-6.png">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-row">
          <div style="height: 4em" />
        </div>
        <div class="container-row">
          <div class="column-item container-left left-align">
            <div class="font-size-large block-title">
              STEP 4          
            </div>
            <div class="font-size-large bold block-title caps">
              Tally it up and play again
            </div>
            <div class="font-size-small ">
              Final scores are revealed and answers are emailed to all players for posterity (and reflection). Now it’s time to play again... and again!
            </div>
          </div>
          <div class="column-item container-right container-fixed-height">
            <div class="main-layout-item main-layout-height">
              <div class="player-image-border">
                <div class="player-image" style="margin-top: 2.5em;">
                  <img src="@/assets/landing/rectangle-1.png">
                </div>
              </div>
              <div class="player-image-border">
                <div class="player-image" style="margin-top: 2.5em;">
                  <img src="@/assets/landing/rectangle-2.png">
                </div>
              </div>
              <div class="player-image-border">
                <div class="player-image" style="margin-bottom: 2.5em;">
                  <img src="@/assets/landing/rectangle-3.png">
                </div>
                <div class="player-image-score score-1">
                  2100 pts
                </div>
              </div>
              <div class="player-image-border">
                <div class="player-image" style="margin-bottom: 2.5em;">
                  <img src="@/assets/landing/rectangle-4.png">
                </div>
                <div class="player-image-score score-2">
                  2800 pts
                </div>
              </div>
              <div class="player-image-border">
                <div class="player-image" style="margin-top: 2.5em;">
                  <img src="@/assets/landing/rectangle-5.png">
                </div>
              </div>
              <div class="player-image-border">
                <div class="player-image" style="margin-bottom: 2.5em;">
                  <img src="@/assets/landing/rectangle-6.png">
                </div>
                <div class="player-image-score score-3">
                  1200 pts
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-row">
          <div style="height: 16em" />
        </div>
        <div class="footer">
          <div>
            © 2023 Weavr |
            <router-link to="/terms">
              Terms and Conditions
            </router-link>
            |
            <router-link to="/privacy">
              Privacy Policy
            </router-link>
          </div>
          <div>
            <a href="mailto:support@weavr.cc">support@weavr.cc</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'HomeView',
  created: function() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    // keeping this as a reference for when we want to redirect to a signup
    signup() {
      this.$auth.loginWithRedirect({ appState: { targetUrl: '/home' }, screen_hint: 'signup' });
    },
    startDemo() {
      this.$router.push({
        name: 'demosetup',
        params: {
          wasRedirectedFromLandingPage: true
        }
      });
    },
    handleScroll() {
      const currentScroll = window.pageYOffset;
      // navbar fades in after scrolling down 200px
      if (currentScroll <= 200) {
        document.querySelector(".navbar.background").style.opacity = currentScroll / 200;
        // console.log(document.querySelector(".logo img").style.filter);
        document.querySelector(".logo img").style.filter = `brightness(${currentScroll / 200}) invert(${1 - currentScroll / 200})`
        document.querySelector(".logo span").style.filter = `brightness(${currentScroll / 200}) invert(${1 - currentScroll / 200})`
      } else {
        document.querySelector(".navbar.background").style.opacity = 1;
        document.querySelector(".logo img").style.filter = 'brightness(1) invert(0)'
        document.querySelector(".logo span").style.filter = 'brightness(1) invert(0)'
        this.displayChevron = false;
      }
    }
  },
  mounted: function() {
    this.handleScroll();
  }
})
</script>

<style scoped lang="scss">
a {
  font-weight: initial;
  color:white;
  &:hover {
    text-decoration: underline;
  }
}

.half-backdrop {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 37.7%;
  left: 0;
  background-color: $brand-teal;
  min-height: 44em;
}

.title-text-1, .title-text-2 {
  font-family: 'Merriweather', 'serif';
  font-size: 3em;
}

.page {
  &-wrapped {
    height: 100vh;
  }
  &-first {
    background-color: $bright-yellow;
  }
  &-second {
    background-color: #5945AB;
    color: white;
  }
  &-third {
    background-color: #4F76C1;
    color: white;
  }
}

.container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: white;
  min-height: 44em;
  padding: 1em 10em;
  &-left {
    display:flex;
    flex-direction: column;
    justify-content: space-evenly;
    width: 40%;
    z-index: 10;
  }
  &-right {
    display:flex;
    flex-direction: column;
    justify-content: space-evenly;
    width: 50%;
  }
  &-fixed-height {
    height: 12em;
  }
  &-title {
    display: flex;
    font-size: 4em;
    border-radius: 0.3em;
    padding-top: 1em;
    justify-content: center;
    align-items: center;
  }
  &-subtitle {
    display: flex;
    font-size: 1em;
    color: $brand-teal;
    justify-content: center;
    align-items: center;
    padding-top: 0.8em;
    padding-bottom: 1.4em;
  }
  &-item {
    display: flex;
    flex-direction: column;
    font-size: 1.3em;
    padding: 0.5em;
    justify-content: center;
    text-align: center;
    align-items: center;
  }
  &-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 100%;
    width: 100%;
    padding: 0 1em;
  }
}

.column-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 1.2em;
  &.padded {
    padding: 1.2em 2em;
  }
  &-longer {
    width: 90%;
    align-self: start;
  }
  &-shorter {
    width: 10%;
    margin-right: 2em;
  }
}

.block-title {
  padding-bottom: 0.4em;
  color: white;
}

.left-align {
  text-align: left;
}

.prompt-item {
  display: flex;
  height: max-content;
  min-height: 4em;
  width: 100%;
  padding: 0.4em 0.8em;
  color: $brand-teal;
  border-radius: 0.2em;
  text-align: center;
  justify-content: center;
  align-items: flex-start;
}

.layout-item {
  position: relative;
  width: 100%;
  padding-bottom: 50%;
}

.container-text-16-9 {
  display: flex;
  position: absolute;
  width: 50%;
  max-height: max-content;
  min-height: 4em;
  align-items: center;
  justify-content: center;
  font-size: 0.6em;
  padding: 0.8em 0.4em;
  border-radius: 0.4em;
  border: 0.2em solid $brand-teal;
  background-color: $off-white;
}

.container-image-16-9 {
  position: absolute;
  width: 50%;
  padding-bottom: 28.125%;
  & img {
    position: absolute;
    object-fit: cover;
    object-position: top;
    left: 0px;
    width: 100%;
    height: 100%;
  }
}

.img {
  &-left {
    top: 35%;
    left: 5%;
    transform: rotate(17deg);
  }
  &-right {
    top: 42%;
    right: 5%;
    transform: rotate(-15deg);
  }
}

.main-layout {
  &-item {
    display: flex;
    position: relative;
    width: 100%;
    height: max-content;
    justify-content: center;
    margin: auto;
  }
  &-half {
    width: 50%;
  }
  &-height {
    height: 100%!important;
  }
}

.circle {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-weight: bold;
  color: $eigengrau;
  border-radius: 50%;
  height: 4em;
  width: 4em;
  &-left {
    position: absolute;
    top: 22%;
    left: -3%;
    background: $bright-yellow;
    font-size: 0.5em;
  }
  &-right {
    position: absolute;
    top: 54%;
    right: -7%;
    background: $bright-yellow;
    font-size: 0.5em;
  }
  &-white {
    position: relative;
    overflow: hidden;
    height: 3em;
    width: 3em;
    background-color: white;
    padding-bottom: 100%;
    img {
      top: 25%;
      left: 25%;
      object-fit: cover;
      object-position: top;
      position: absolute;
      width: 50%;
    }
  }
}

.gif-prompt-example {
  width: max-content;
  height: max-content;
  padding: 0.4em 0.6em;
  margin: 0 auto;
  border-radius: 0.4em;
  background-color: $off-white;
  margin: auto;
  &-title {
    font-size: 0.6em;
    text-align: center;
    color: $eigengrau;
  }
  &-search-box {
    color: $light-smoke-gray;
    font-size: 0.4em;
    padding: 0.5em 0.6em;
    margin: 1em;
    text-align: left;
    border-radius: 0.2em;
    border: 0.1em solid $smoke-gray;
  }
}

.player-image {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-bottom: 100%;
  border-radius: 50%;
  & img {
    position: absolute;
    object-fit: cover;
    object-position: top;
    left: 0px;
    width: 100%;
    height: 100%;
  }

  &-border {
    font-size: 0.72em;
    position: relative;
    display: flex;
    align-items: center;
    width: 4em;
    border-radius: 50%;
    margin: 0.5%;
    padding: 0.1em;

    &.align-bottom {
      align-items: flex-end!important;
    }
  }

  &-border-absolute {
    font-size: 0.72em;
    $border-width: 4em;
    position: absolute;
    display: flex;
    align-items: center;
    width: $border-width;
    border-radius: 50%;
    margin: 0.5%;
    padding: 0.1em;
    left: calc(50% - #{$border-width / 2});
    top: calc(50% - #{$border-width / 2});

    $radius: -9em;
    $radius-2: -11em;

    // classes for the hexagon shape without offset
    &.deg0 {
      transform: rotate(0deg) translateY($radius);
    }
    &.deg60 {
      transform: rotate(60deg) translateY($radius-2) rotate(-60deg);
    }
    &.deg120 {
      transform: rotate(120deg) translateY($radius-2) rotate(-120deg);
    }
    &.deg180 {
      transform: rotate(180deg) translateY($radius) rotate(-180deg);
    }
    &.deg240 {
      transform: rotate(240deg) translateY($radius-2) rotate(-240deg);
    }
    &.deg300 {
      transform: rotate(300deg) translateY($radius-2) rotate(-300deg);
    }
    // classes for the hexagon shape with one radius
    &.deg0-circular {
      transform: rotate(0deg) translateY($radius);
    }
    &.deg60-circular {
      transform: rotate(60deg) translateY($radius) rotate(-60deg);
    }
    &.deg120-circular {
      transform: rotate(120deg) translateY($radius) rotate(-120deg);
      &::after {
        display: flex;
        align-items: center;
        justify-content: center;
        content: '\25BC';
        position: absolute;
        width: 1em;
        height: 1em;
        color: white;
        left: calc(50% - 0.5em);
        top: calc(50% - 0.5em);
        transform: rotate(135deg) translateY(2.5em) rotate(180deg);
      }
    }
    &.deg180-circular {
      transform: rotate(180deg) translateY($radius) rotate(-180deg);
    }
    &.deg240-circular {
      transform: rotate(240deg) translateY($radius) rotate(-240deg);
    }
    &.deg300-circular {
      transform: rotate(300deg) translateY($radius) rotate(-300deg);
      &::after {
        display: flex;
        align-items: center;
        justify-content: center;
        content: '\25BC';
        position: absolute;
        width: 1em;
        height: 1em;
        color: white;
        left: calc(50% - 0.5em);
        top: calc(50% - 0.5em);
        transform: rotate(-45deg) translateY(2.5em) rotate(180deg);
      }
    }
    // classes for the hexagon shape with a 30 degree offset
    &.deg30 {
      transform: rotate(30deg) translateY($radius) rotate(-30deg);
    }
    &.deg90 {
      transform: rotate(90deg) translateY($radius-2) rotate(-90deg);
    }
    &.deg150 {
      transform: rotate(150deg) translateY($radius) rotate(-150deg);
      &::after {
        display: flex;
        align-items: center;
        justify-content: center;
        content: '\25BC';
        position: absolute;
        width: 1em;
        height: 1em;
        color: white;
        left: calc(50% - 0.5em);
        top: calc(50% - 0.5em);
        transform: rotate(135deg) translateY(2.5em) rotate(180deg);
      }
    }
    &.deg210 {
      transform: rotate(210deg) translateY($radius) rotate(-210deg);
    }
    &.deg270 {
      transform: rotate(270deg) translateY($radius-2) rotate(-270deg);
    }
    &.deg330 {
      transform: rotate(330deg) translateY($radius) rotate(-330deg);
      &::after {
        display: flex;
        align-items: center;
        justify-content: center;
        content: '\25BC';
        position: absolute;
        width: 1em;
        height: 1em;
        color: white;
        left: calc(50% - 0.5em);
        top: calc(50% - 0.5em);
        transform: rotate(-45deg) translateY(2.5em) rotate(180deg);
      }
    }
  }
  &-score {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    background: $bright-yellow;
    color: $eigengrau;
    text-align: center;
    font-size: 0.6em;
    font-weight: bold;
    height: 5em;
    width: 5em;
    border-radius: 50%;
    &.score-1 {
      left: -37.5%;
      bottom: 62%;
    }
    &.score-2 {
      right: -37.5%;
      bottom: 62%;
    }
    &.score-3 {
      right: -37.5%;
      bottom: 62%;
    }
  }
}

.code {
  &-item {
    position: absolute;
    display: flex;
    align-items: center;
  }
  &-content {
    font-size: 0.8em;
    padding: 0.4em 0.8em;
    border-radius: 0.4em;
    background-color: $crimson;
  }
}

.register-button {
  display: flex;
  justify-content: center;
  align-items: center;
  color: $natural-white;
  background-color: $lilac-purple;
  text-align: center;
  margin-top: 2em;
  padding: 0.8em 1em;
  height: max-content;
  width: max-content;
  font-size: 1.2em;
  border: 0.1em $smoke-gray solid;
  border-radius: 0.4em;
  box-shadow: 0 1px 1px 1px $eigengrau;
  cursor: pointer;
  &-container {
    display: flex;
    align-items: center;
    height: max-content;
    margin-top: 2em;
    margin-bottom: 12em;
  }
  &-content {
    margin: 0 0.5em;
    flex: 1;
  }  
  &:hover {
    filter: brightness(1.15);
  }
}

.footer {
  display: flex;
  width: 100%;
  font-size: 0.8em;
  padding: 0 1em;
  justify-content: space-between;
}

.font-size {
  &-large {
    font-size: 0.85em;

    &.bold {
      font-weight: bold;
    }
  }
  &-reg {
    font-size: 0.7em;
  }
  &-small {
    font-size: 0.65em;
  }
}

</style>
